export default "__VITE_ASSET__C7nUG5pt__"